import { EDGE_SERVER_IGNORED_FIELDS } from "Areas/SharedFeatures/types/edgeSource";
import { NODE_SERVER_IGNORED_FIELDS } from "Areas/SharedFeatures/types/nodeSource";
import filter from "lodash/filter";
import flatMap from "lodash/flatMap";
import map from "lodash/map";
import omit from "lodash/omit";
import createGraphSnapshot from "../createGraphSnapshot";
import getGraphEdgeSources from "../nodeOrEdgeSourceDataHandling/getGraphEdgeSources";
import getGraphNodeSources from "../nodeOrEdgeSourceDataHandling/getGraphNodeSources";
import { setToLocalStorage } from "./localStorageUtils";
export default (graphComponentRef, documentId, onSetHasPasteData) => {
    if (!graphComponentRef.current)
        return undefined;
    return () => {
        if (!documentId)
            return;
        const component = createGraphSnapshot(graphComponentRef, true);
        if (!component)
            return;
        const nodes = component.graph.nodes.toArray();
        const edges = component.graph.edges.toArray();
        const groupNodesSources = map(filter(nodes, node => { var _a; return Boolean((_a = node.tag) === null || _a === void 0 ? void 0 : _a.Nodes); }), node => node.tag);
        const pasteData = {
            FromDocumentId: documentId,
            ToDocumentId: 0,
            NodesSource: map(flatMap(nodes, getGraphNodeSources), (e) => omit(e, NODE_SERVER_IGNORED_FIELDS)),
            EdgesSource: map(flatMap(edges, getGraphEdgeSources), (e) => omit(e, EDGE_SERVER_IGNORED_FIELDS)),
            Groups: map(groupNodesSources, (g) => {
                var _a, _b;
                return ({
                    Id: g.GroupId,
                    Name: (_a = g.GroupName) !== null && _a !== void 0 ? _a : "Группа",
                    ObjectCount: (_b = g.GroupObjectCount) !== null && _b !== void 0 ? _b : 0
                });
            })
        };
        setToLocalStorage(pasteData);
        onSetHasPasteData(true);
    };
};
